// Shadow parts exports for fan-pass-claim component

export const loginShadowParts = `
  base-body,
  base-button,
  base-button-label,
  base-button-link,
  base-button-link-label,
  base-disconnect-button,
  base-disconnect-button-label,
  base-form-layout,
  base-form-resend-otp-text,
  base-input,
  base-login-button,
  base-login-button-label,
  base-login-input,
  base-login-layout,
  base-otp-email,
  base-otp-email-layout,
  base-otp-email-text,
  base-otp-layout,
  base-resend-otp-link,
  base-resend-otp-link-label,
  base-submit-otp-button,
  base-submit-otp-button-label,
  base-text,
  button,
  button-label,
  button-link,
  button-link-label,
  disconnect-button,
  disconnect-button-label,
  flow-container,
  base-flow-container,
  form-layout,
  form-resend-otp-layout,
  base-form-resend-otp-layout,
  form-resend-otp-text,
  login-button,
  login-button-label,
  login-email-form,
  login-input,
  login-layout,
  otp-email,
  otp-email-layout,
  otp-email-text,
  otp-layout,
  otp-form-layout,
  base-otp-form-layout,
  resend-otp-link,
  resend-otp-link-label,
  submit-otp-button,
  submit-otp-button-label
`.trim().replace(/\s+/g, ' ');

export const frameShadowParts = `
  base-brand,
  base-flow-content-layout,
  base-flow-pager,
  base-footer-layout,
  base-frame-layout,
  base-legal-layout,
  base-logo-content-container,
  brand-image,
  brand-text,
  flow-content-layout,
  flow-pager,
  flow-footer-layout,
  base-flow-footer-layout,
  frame-layout,
  legal-layout,
  legal-links-layout,
  base-legal-links-layout,
  logo-content-container,
  pager,
  pager-dot
`.trim().replace(/\s+/g, ' ');

export const connectedShadowParts = `
  account-connected,
  account-connected-content,
  account-connected-layout,
  account-connected-text,
  account-user-email,
  base-account-connected,
  base-account-connected-layout,
  base-account-connected-text,
  base-account-user-email,
  base-body,
  base-button-icon,
  base-button-link,
  base-button-link-label,
  base-disconnect-link,
  base-disconnect-link-label,
  base-powered-by-layout,
  base-powered-by-text,
  base-text,
  body,
  button-icon,
  button-link,
  button-link-label,
  connecting-spinner,
  disconnect-link,
  disconnect-link-label,
  ellipsis-button,
  ellipsis-icon,
  popover,
  popover-container,
  popover-content,
  popover-positioning-container,
  powered-by-layout,
  powered-by-text
`.trim().replace(/\s+/g, ' ');

